import { useLocation, useNavigate } from "react-router-dom";
import { CardsIcon } from "../components/CardsIcon";
import { Footer } from "../components/Footer";
import { Logo } from "../components/Logo";

interface LocationState {
  email?: string;
  debugMagicLinkUrl?: string;
}

export function LoginSentPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = (location.state as LocationState) ?? {};
  const email = state.email;
  const debugMagicLinkUrl = state.debugMagicLinkUrl;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 py-10">
      <div className="flex w-full max-w-md flex-1 flex-col items-center justify-center">
        <CardsIcon className="mb-4 h-16 w-16" color="#FF5100" />
        <div className="card w-full text-center">
          <Logo className="mx-auto h-8" color="#FF5100" />

          <h1 className="mt-6 text-2xl font-bold text-ink">
            Vérifie ta boîte mail
          </h1>

          <p className="mt-4 text-sm text-smoke">
            Un lien de connexion a été envoyé à{" "}
            <span className="font-semibold text-ink">
              {email ?? "ton adresse"}
            </span>
            .
          </p>

          <p className="mt-2 text-sm text-smoke">
            Ouvre le lien depuis le navigateur pour finaliser la session.
          </p>

          {debugMagicLinkUrl ? (
            <a href={debugMagicLinkUrl} className="btn-primary mt-6 block">
              Ouvrir le lien de dev
            </a>
          ) : null}

          <button
            type="button"
            className="btn-secondary mt-4 w-full"
            onClick={() => navigate("/login")}
          >
            Retour à la connexion
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}
